import { DestroyRef, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BehaviorSubject,
  distinctUntilChanged,
  map,
  tap,
  withLatestFrom,
} from 'rxjs';
import { AppState } from '../../reducers/index';
import { selectFeedSearchQuery } from '../reducers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Actions, ofType } from '@ngrx/effects';
import { objectChanged } from '../actions/core.actions';

@Injectable({
  providedIn: 'root',
})
export class AdvancedSearchService {
  private searchQuerySubject = new BehaviorSubject<string>('');
  searchQuery$ = this.searchQuerySubject.asObservable();

  private store = inject(Store<AppState>);
  private actions$ = inject(Actions);
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.actions$
      .pipe(
        ofType(objectChanged),
        withLatestFrom(this.store.select(selectFeedSearchQuery)),
        map(([, query]) => query),
        distinctUntilChanged(),
        tap((query) => this.setQuery(query)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  setQuery(query: string) {
    this.searchQuerySubject.next(query);
  }
}
